const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

export const normalizeRecipientList = (value) => {
  const values = Array.isArray(value) ? value : String(value || "").split(/[;,\n]+/);
  const seen = new Set();
  return values.reduce((emails, entry) => {
    const email = String(entry || "").trim().toLowerCase();
    if (!EMAIL_RX.test(email) || seen.has(email)) return emails;
    seen.add(email);
    emails.push(email);
    return emails;
  }, []);
};

export const normalizePurchaseOrderEmailRow = (row = {}) => {
  const raw = row?._poRaw || {};
  const supplierInfo = row?.supplierInfo || raw?.supplierInfo || {};
  const resolved = row?.resolvedRecipients || raw?.resolvedRecipients || {};
  const productionRepDetails = row?.productionRepDetails || raw?.productionRepDetails || null;
  const supplierEmail =
    row?.supplierEmail || supplierInfo?.supplierEmail || raw?.supplierEmail || raw?.supplierInfo?.supplierEmail || "";
  const purchasingRepEmail = productionRepDetails?.email || "";

  return {
    ...row,
    supplierEmail,
    productionRepDetails,
    resolvedRecipients: {
      ...resolved,
      to: normalizeRecipientList(resolved?.to?.length ? resolved.to : supplierEmail),
      cc: normalizeRecipientList([...normalizeRecipientList(resolved?.cc), purchasingRepEmail]),
      bcc: normalizeRecipientList(resolved?.bcc),
    },
  };
};

export const recipientFieldsFromPurchaseOrder = (row = {}) => {
  const normalized = normalizePurchaseOrderEmailRow(row);
  return {
    row: normalized,
    to: normalized.resolvedRecipients.to.join(", "),
    cc: normalized.resolvedRecipients.cc.join(", "),
    bcc: normalized.resolvedRecipients.bcc.join(", "),
  };
};
